/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSectorRegular: {
  name: 'sector-regular';
  data: string;
} = {
  name: 'sector-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.47 3.08c-.441.113-.943.494-1.189.902-.296.493-.276-.082-.276 8.018 0 6.734.005 7.279.068 7.523.18.689.787 1.272 1.476 1.418.406.086 14.496.086 14.902 0 .373-.079.643-.233.949-.541.452-.454.587-.849.546-1.6-.132-2.432-.988-5.201-2.292-7.41A17.027 17.027 0 0 0 6.14 3.139c-.605-.078-1.474-.109-1.67-.059m1.25 2.019c3.966.468 7.52 2.448 10.037 5.592 1.777 2.218 2.936 5.127 3.187 7.999l.027.31H5V5.04h.11c.061 0 .335.027.61.059"/></svg>`
};
